import Nav from 'react-bootstrap/Nav'
import Icon from '../../../components/Icon.jsx';
import { addNotification, NotificationTypes } from "../../../stores/notification-store.js";

export default function ProfileTools(props) {

    // Action toolbar
    const handleToolSelect = item => {
        if (item == 'copyconfig') {
            // place the config data on the users clipboard if the browser supports it
            if (navigator && navigator.clipboard && navigator.clipboard.writeText)
            {
                navigator.clipboard.writeText(JSON.stringify(props.profile.componentProfile.config, null, 2));
                addNotification(`The profile data has been copied to your clipboard.`, 'success', false, 'Copy Succeeded')
            }
            else {
                addNotification('This browser does not support copying data to the clipboard.', 'info', false, 'Copy Failed')
            }
        }
        if (item == 'about') {
            console.log('not implemented yet')
        }
    }
    
    return (
        <Nav className="justify-content-end ms-auto" onSelect={handleToolSelect}>
        {/* <Nav.Item>
            <Nav.Link eventKey="about"><Icon icon="info-circle" width={24} height={24}></Icon> About</Nav.Link>
        </Nav.Item> */}
        <Nav.Item>
            <Nav.Link eventKey="copyconfig"><Icon icon="plus-circle" width={24} height={24}></Icon> Copy Profile</Nav.Link>
        </Nav.Item>
        </Nav>
    )
}